import React from "react";
import { Link } from "react-router-dom";
import { FaStar, FaPlay, FaCoffee, FaFlag, FaShippingFast } from "react-icons/fa";

const trust = [
  { icon: FaStar, label: "4.9 (250+ Reviews)" },
  { icon: FaCoffee, label: "Freshly Roasted Weekly" },
  { icon: FaFlag, label: "100% Rwandan Arabica" },
  { icon: FaShippingFast, label: "Ships Within 24 Hours" },
];

const Hero = () => {
  return (
    <section className="relative min-h-[100svh] w-full overflow-hidden bg-espresso">
      <img
        src="/hero-slide.png"
        alt="KBL Coffee — bag, cup, and cherries overlooking Rwandan highlands"
        className="absolute inset-0 h-full w-full object-cover object-[68%_center]"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-espresso/88 via-espresso/50 to-transparent" />
      <div className="absolute inset-0 bg-gradient-to-t from-espresso/45 via-transparent to-espresso/25" />

      <div className="relative z-10 mx-auto flex min-h-[100svh] max-w-7xl items-center px-4 pb-14 pt-28 sm:px-6 sm:pb-16 sm:pt-32 md:px-8 lg:pt-28">
        <div className="max-w-xl animate-fade-up lg:max-w-2xl">
          <h1 className="font-display text-[2.15rem] leading-[1.1] text-cream sm:text-5xl md:text-6xl lg:text-[4.15rem]">
            Experience Rwanda&apos;s Finest{" "}
            <span className="text-gold">Specialty Coffee</span>
          </h1>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-cream/90 sm:mt-5 sm:text-base md:text-lg">
            Ethically sourced single-origin coffee from women-led farms in Rulindo, Kamonyi, or Karongi—never blended across districts.
            Freshly roasted for cafés, homes and businesses.
          </p>

          <div className="mt-6 flex w-full flex-col gap-3 sm:mt-8 sm:w-auto sm:flex-row sm:flex-wrap">
            <Link
              to="/product"
              className="inline-flex items-center justify-center rounded-md bg-[#2A1810] px-8 py-3.5 text-sm font-semibold tracking-wide text-cream shadow-lg transition hover:bg-espresso-soft"
            >
              Shop Coffee
            </Link>
            <a
              href="#story"
              className="inline-flex items-center justify-center gap-2.5 rounded-md border border-cream px-8 py-3.5 text-sm font-semibold tracking-wide text-cream transition hover:bg-cream/10"
            >
              <span className="flex h-5 w-5 items-center justify-center rounded-full border border-cream">
                <FaPlay className="ml-0.5 text-[8px]" />
              </span>
              Watch Our Story
            </a>
          </div>

          <div className="mt-8 flex items-center gap-3 text-sm text-cream/90">
            <div className="flex gap-1 text-gold">
              {[...Array(5)].map((_, i) => (
                <FaStar key={i} />
              ))}
            </div>
            <span>4.9/5 from 500+ happy coffee lovers</span>
          </div>

          <div className="mt-8 grid grid-cols-1 gap-3 sm:grid-cols-2">
            {trust.map(({ icon: Icon, label }) => (
              <div
                key={label}
                className="flex items-center gap-2.5 rounded-lg border border-cream/20 bg-espresso/35 px-3.5 py-2.5 text-sm text-cream/95 backdrop-blur-sm"
              >
                <Icon className="shrink-0 text-gold" />
                <span>{label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
